import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const GET_CMS_PROVIDER_BY_NPI = "GET_CMS_PROVIDER_BY_NPI";

export const service = async (cmsProvider) => {
  const options: object = {
    url: "/api/lookup/GetCMSProviderByNPI",
    method: "POST",
    body: JSON.stringify(cmsProvider),
    ...getDefaultOptions(),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_CMS_PROVIDER_BY_NPI, service, mock);
